<template>
  <body class="body">
    <div class="container" id="formContent">
      <div class="updown">
        <img style="width: 15vw" src="../img/bees/bine.png"/>
      </div>
      <h2> Salut! </h2>
      <p> Ți-am pregătit un set care cuprinde 47 de teste recapitulative, 
        din matematica de gimnaziu. Le-am organizat pe ani de
        studiu și capitole. La finalul anului școlar, primii 3 
        elevi cu cele mai mari punctaje totale vor fi premiați.
      </p>
      <p>Acestora le vom trimite diplome, individual, pe 
        adresa de mail.
      </p>
      <p>Mult succes!</p>
      <p>Echipa SmartHoneyBee</p>
      <h4>
        Ce dorești să faci mai departe?
      </h4>
      <div>
        <router-link :to="{name: 'classes'}">
          <button type="button" class="buton btn" style="margin-right: 2vh;">
            Teste
          </button>
        </router-link>

        <router-link :to="{name: 'profile'}">
          <button type="button" class="buton btn">
            Rezultate
          </button>
        </router-link>
      </div>
    </div>
  </body>
</template>

<script>
export default {
  name: 'Home',
}
</script>

<style scoped>
.body {
 background-color: #FBEFDA;
 display: flex;
 align-content: center;
 justify-content: center;
 flex-direction: column;
 height: 100%;
}

.buton {
  text-align: center;
  border-radius:40px;
  background: #F7CCA1;
  border: 2px solid #F7CCA1;
  color:#F7CCA1;
  letter-spacing:1px;
  color: black;
}

.container {
  display: flex;
  justify-content: center;
  align-content: center;
  flex-direction: column;
}

#formContent {
  -webkit-border-radius: 10px 10px 10px 10px;
  border-radius: 10px 10px 10px 10px;
  background: #fff;
  padding: 30px;
  width: 80%;
  position: relative;
  -webkit-box-shadow: 0 10px 10px 0 rgba(0,0,0,0.3);
  box-shadow: 0 10px 10px 0 rgba(0,0,0,0.3);
  text-align: center;
  margin-bottom: 2%;
}
</style>
